import { FetchMonthlyPOBOrdersData } from "../../../domain/useages/daily-pob-report/fetch-monthly-pob-orders-data";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";

export class RemoteFetchMonthlyPOBOrdersData
  implements FetchMonthlyPOBOrdersData
{
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) {}

  async fetch(
    month: number,
    year: number,
    params: FetchMonthlyPOBOrdersData.Params
  ): Promise<any> {
    const monthString = month.toString().padStart(2, "0");

    const httpResponse = await this.httpGetClient.get({
      url: this.url
        .replace(":month", monthString)
        .replace(":year", year.toString()),
      query: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    } else {
      throw new Error("Failed to fetch count POB data summary");
    }
  }
}
